import React from 'react';
import { IChipRow } from './types';
import { useTranslation } from 'react-i18next';
import Label from 'src/components/Label';

export const ChipRow = ({ column, item, ...props }: IChipRow) => {
    const { t } = useTranslation();

    const { field } = column;
    const status = item[field];

    const isActive = !!status;
    const label = isActive ? 'Keys.IsActiveTrue' : 'Keys.IsActiveFalse';

    return <Label color={isActive ? 'success' : 'error'}>{t(label)}</Label>;
};
